import PropTypes from 'prop-types';
import React from 'react';
import i18n from '../../i18n';
import Exchange from '../../models/Exchange';
import Home from '../../models/Home';
import User from '../../models/User';

export default class OverlayTransformToMutual extends React.Component {
    static propTypes = {
        exchange: PropTypes.instanceOf(Exchange).isRequired,
        user: PropTypes.instanceOf(User).isRequired,
        changeToReciprocal: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);
        this.handleChangeToReciprocal = this.handleChangeToReciprocal.bind(this);
    }

    handleChangeToReciprocal(event) {
        event.preventDefault();
        event.target.setAttribute('disabled', true);
        this.props.changeToReciprocal(this.props.exchange.get('home'));
    }

    render() {
        if (this.props.exchange.id) {
            return false;
        }

        const homeUnavailable =
            !this.props.exchange.get('home') ||
            this.props.exchange.get('home').get('status') != Home.STATUS_ONLINE;

        if (homeUnavailable) {
            return <div className="overlay" />;
        }

        return (
            <div className="overlay transform-to-reciprocal">
                <button className="btn btn-primary" onClick={this.handleChangeToReciprocal}>
                    {i18n.t('exchange:transform_to_reciprocal')}
                </button>
                {(() => {
                    if (this.props.exchange.get('host').id == this.props.user.id) {
                        return (
                            <p>
                                {i18n.t('exchange:user_could_come_home', {
                                    first_name: this.props.exchange.get('guest').get('first_name')
                                })}
                            </p>
                        );
                    } else {
                        return (
                            <p>
                                {i18n.t('exchange:you_can_go_to', {
                                    first_name: this.props.exchange.get('host').get('first_name')
                                })}
                            </p>
                        );
                    }
                })()}
            </div>
        );
    }
}
